var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isTextToImage
    ? _c("div", { staticClass: "image-effects-test-prompt" }, [
        _c(
          "div",
          {
            staticClass:
              "form-group mb-0 d-flex align-items-end prompt-row mb-4",
            class: { "prompt-row--stacked": _vm.alwaysStacked },
          },
          [
            _c(_setup.CInput, {
              staticClass: "flex-grow-1",
              attrs: {
                type: "text",
                placeholder: "Type a prompt to generate a test image",
                label: "Type a prompt to generate a test image",
              },
              model: {
                value: _setup.prompt,
                callback: function ($$v) {
                  _setup.prompt = $$v
                },
                expression: "prompt",
              },
            }),
            _vm._v(" "),
            _c(_setup.CButton, {
              attrs: {
                size: "md",
                text: "Generate",
                variant: "light",
                disabled: !_setup.prompt.trim(),
              },
              on: { click: _setup.handleGenerate },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }